import React, { useState } from 'react';

import styled from 'styled-components';

import { DAY_SELECT_OPTIONS } from 'constants/dateAndTime';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';
import { TotemSelect } from 'components/TotemSelect';

import { urbantzRoundPresetsUpdatedOrCreatedHandler } from '../cacheHandlers/urbantzRoundPresetsCacheHandler';

import { useCreateUrbantzRoundPresetMutation, TotadminPermission } from 'data/__generated__';

export function CreateUrbantzRoundPresetPopup({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
}) {
    const [selectedDay, setSelectedDay] = useState<number | null>(null);

    const [createUrbantzRoundPreset, { loading: creationLoading }] = useCreateUrbantzRoundPresetMutation();

    async function handleSubmit() {
        if (!selectedDay) {
            return;
        }
        const { data } = await createUrbantzRoundPreset({ variables: { dayIndex: selectedDay } });

        if (!data?.createUrbantzRoundPreset) {
            throw new Error('Une erreur est survenue lors de la création de la tournée prédéfinie');
        }

        const { createUrbantzRoundPreset: newUrbantzRoundPreset } = data;

        urbantzRoundPresetsUpdatedOrCreatedHandler([newUrbantzRoundPreset]);

        setIsOpen(false);
    }

    return (
        <TotemPopup
            title="Ajouter une tournée prédéfinie"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            <TotemSelect
                placeholder="Sélectionner un jour"
                disabled={creationLoading}
                value={selectedDay}
                options={DAY_SELECT_OPTIONS}
                onChange={(value) => {
                    if (value !== null) {
                        setSelectedDay(value);
                    }
                }}
            />
            <SubmitContainer>
                <ValidationButton
                    onClick={handleSubmit}
                    loading={creationLoading}
                    useIcon={false}
                    label="Confirmer"
                    requiredPermissions={[TotadminPermission.ToursManage]}
                />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15px;
`;

const ValidationButton = styled(TotemPrimaryLoadingButton)`
    margin-top: 15px;
`;
